import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getSocket } from '../actions/socket';

/**
 * Hook which returns the last event of a certain type.
 * Use this to subscribe to events outside of redux.
 *
 * e.g.
 * const lastEvent = useLiveEvent('category:event1');
 *
 * @param eventType  - type of the event.
 * @returns {object} - data received for that event.
 */
const useLiveEvent = (eventType) => {
  const socketId = useSelector((state) => state.socket.id);
  const [data, setData] = useState();

  useEffect(() => {
    const socket = getSocket();
    if (!socket) {
      return;
    }
    const handleEvent = (eventPayload) => {
      setData(eventPayload);
    };
    // at this point the socket should be connected
    if (socketId) {
      socket.on(eventType, handleEvent);
    }
    // We can either return undefined or a cleanup function from the effect
    // eslint-disable-next-line consistent-return
    return () => {
      socket.off(eventType, handleEvent);
    };
  }, [socketId, eventType]);

  return data;
};

export default useLiveEvent;
